import {setBackgroundColor,hideSplash,elementIdExists, FontIconsLoaded} from './common.js'
import App from './App.svelte';
import { navbarTitle } from './store.js';
import { startPrep } from './init.js';

let cssGlobalReady=false;
let cssBundleReady=false;
let backgroundImageReady=false;

//set some properties
startPrep();

console.log('get files 2');

let datafile = "datajs";

if(window.location.href.toLowerCase().indexOf("preview") > -1){
    datafile = 'datapreviewjs';
}

Promise.all([
    //to do get all svg dynamic
    fetch('/svgicons.json').then(res=> res.json()),
    //fetch("/data.json").then(res=> res.json())
    fetch('https://igappfiles.azureedge.net/data/'+appId+'/'+ datafile +'.json?v='+ encodeURIComponent(userAppDataHash)).then(res=> res.json())
    ]).then(([resicons, resdata]) => {

    //icons
    for (const icon of resicons.values()){
        svgIcons.push(icon);
    }

    //data
    for (const d of resdata.values()){
        views.push(d);
    }
    
    //check css and background
    checkCssAndBackgroundImageAndLoad();

}).catch((err) => {
    console.log(err);
});

function checkCssAndBackgroundImageAndLoad(){
    cssGlobalReady = elementIdExists('igstyleglobal');
    cssBundleReady = elementIdExists('igstylebundle');
    backgroundImageReady = elementIdExists('igbackground');
    FontIconsLoaded
    if(FontIconsLoaded() && cssGlobalReady && cssBundleReady  && backgroundImageReady && appBackground){
        console.log('load App')
     
        loadApp();
    }else{
        console.log('App not ready')
        console.log('css global:'+ cssGlobalReady);
        console.log('css:'+ cssBundleReady);
        console.log('background'+ backgroundImageReady);
        console.log('backgroundcolor'+ appBackground);
        setTimeout(checkCssAndBackgroundImageAndLoad,100);
    }
}

function loadApp(){
    console.log('start app');
    //router(routes);
    window.svelteApp = new App({
        target: document.getElementById('app'),
        props: {
            
        }
    });
    navbarTitle.set(appDisplayName);
    hideSplash();
}